import { FC, Fragment } from 'react';

import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/solid';
import { useAuth } from '@shared/state/hooks/useAuth';
import { classNames } from '@shared/utils/joinClassNamesUtils';

export const GiftSellerTopBar: FC = function GiftSellerTopBar() {
  const { userProfile, apiLogout } = useAuth();

  return (
    <div className="flex justify-end pt-2 pr-[160px]">
      <Menu as="div" className="relative">
        <Menu.Button className="flex items-center gap-1 rounded-full bg-white/80 px-3 py-1 text-sm font-medium text-gray-700 shadow-sm ring-1 ring-black/5 backdrop-blur hover:bg-white focus:outline-none">
          <span>{userProfile?.info?.name ?? '사용자'}님</span>
          <ChevronDownIcon className="h-4 w-4 text-gray-400" aria-hidden="true" />
        </Menu.Button>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute right-0 mt-2 w-36 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <Menu.Item>
              {({ active }) => (
                <button
                  className={classNames(
                    active ? 'bg-gray-100' : '',
                    'block w-full px-4 py-2 text-left text-sm text-gray-700',
                  )}
                  onClick={() => {
                    apiLogout();
                  }}
                >
                  로그아웃
                </button>
              )}
            </Menu.Item>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  );
};
